import { useAuthStore } from '@clarix/auth-store';

/**
 * PMS routes are workspace-slug-prefixed (`/:slug/pms/*`). The gateway routes by
 * the slug segment but injects workspace identity from the JWT, so the slug just
 * has to be the active workspace. Read it from the auth store (same source the
 * api-client sends as X-Workspace-Slug).
 */
export function pmsBase(): string {
  const slug = useAuthStore.getState().workspaceSlug;
  if (!slug) throw new Error('No active workspace selected');
  return `/${slug}/pms`;
}

/**
 * The same base, for a slug supplied by the CALLER rather than the session.
 *
 * The §12 token routes are reached by an employee who is signed out — and who may
 * have no Clarix account at all, since a directory-only membership has
 * `user_id = null`. `pmsBase()` throws for them ("No active workspace selected"),
 * which is precisely why the mailed link was unreachable from the frontend.
 *
 * The slug comes from the hostname of the link the employee opened
 * (`{slug}.clarix.app`). The shell resolves it — it owns `getWorkspaceSlug` — and
 * passes it in, so PMS never has to parse a hostname or import shell source.
 */
export function pmsBaseFor(slug: string): string {
  if (!slug) throw new Error('No workspace in this link');
  return `/${slug}/pms`;
}
